module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transctl"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("交易管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel down"
  }, [_c('div', {
    staticClass: "panel-header panel-header__auto"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formrules
    }
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("时间")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "dateRangeValue"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "editable": false,
      "placeholder": "选择日期范围",
      "size": "small",
      "clearable": false
    },
    model: {
      value: (_vm.form.dateRangeValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "dateRangeValue", $$v)
      },
      expression: "form.dateRangeValue"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "choosetime"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeTime
    },
    model: {
      value: (_vm.form.choosetime),
      callback: function($$v) {
        _vm.$set(_vm.form, "choosetime", $$v)
      },
      expression: "form.choosetime"
    }
  }, _vm._l((_vm.choosetimes), function(item) {
    return _c('el-radio-button', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [(!_vm.role.single) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("店铺名称")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "selectShopUid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small"
    },
    on: {
      "change": function($event) {
        return _vm.getOperators(_vm.form.selectShopUid)
      }
    },
    model: {
      value: (_vm.form.selectShopUid),
      callback: function($$v) {
        _vm.$set(_vm.form, "selectShopUid", $$v)
      },
      expression: "form.selectShopUid"
    }
  }, _vm._l((_vm.shopData.list), function(shop) {
    return _c('el-option', {
      key: shop.uid,
      attrs: {
        "label": shop.shop_name,
        "value": shop.uid
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.role.isCashier) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("收银员")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "operaValue"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small",
      "disabled": _vm.form.selectShopUid === ''
    },
    on: {
      "change": _vm.operaChange
    },
    model: {
      value: (_vm.form.operaValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "operaValue", $$v)
      },
      expression: "form.operaValue"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.operaList), function(label, value) {
    return _c('el-option', {
      key: value,
      attrs: {
        "label": label,
        "value": value
      }
    })
  })], 2)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("收款方式")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkAll1"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleCheckAllChange1
    },
    model: {
      value: (_vm.form.checkAll1),
      callback: function($$v) {
        _vm.$set(_vm.form, "checkAll1", $$v)
      },
      expression: "form.checkAll1"
    }
  }, [_vm._v("不限")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "type"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedCitiesChange1
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("更多筛选")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkAll2"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleCheckAllChange2
    },
    model: {
      value: (_vm.form.checkAll2),
      callback: function($$v) {
        _vm.$set(_vm.form, "checkAll2", $$v)
      },
      expression: "form.checkAll2"
    }
  }, [_vm._v("不限")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "other"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedCitiesChange2
    },
    model: {
      value: (_vm.form.other),
      callback: function($$v) {
        _vm.$set(_vm.form, "other", $$v)
      },
      expression: "form.other"
    }
  }, _vm._l((_vm.otherList), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper orderno_nowrap"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("流水号")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "orderno"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input__fix panel-select-input-220",
    attrs: {
      "type": "number",
      "placeholder": "请输入流水号",
      "size": "small"
    },
    model: {
      value: (_vm.form.orderno),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderno", $$v)
      },
      expression: "form.orderno"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn-group"
  }, [_c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill",
    on: {
      "click": _vm.search
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v("查询")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn transctl-btn",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-btn-group__wrapper panel-body-btn-group flex-normal"
  }, [_c('div', {
    staticClass: "num_total"
  }, [_c('div', {
    staticClass: "num_wrapper"
  }, [_c('p', {
    staticClass: "num-title"
  }, [_vm._v("交易总金额")]), _vm._v(" "), _c('p', {
    staticClass: "num-desc"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.transData.sucamt)) + " " + _vm._s(_vm.role.currency))])]), _vm._v(" "), _c('div', {
    staticClass: "num_wrapper"
  }, [_c('p', {
    staticClass: "num-title"
  }, [_vm._v("交易实收")]), _vm._v(" "), _c('p', {
    staticClass: "num-desc"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.transData.total_txamt)) + " " + _vm._s(_vm.role.currency))])]), _vm._v(" "), _c('div', {
    staticClass: "num_wrapper"
  }, [_c('p', {
    staticClass: "num-title"
  }, [_vm._v("红包优惠")]), _vm._v(" "), _c('p', {
    staticClass: "num-desc"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.transData.coupon_amt)) + " " + _vm._s(_vm.role.currency))])]), _vm._v(" "), _c('div', {
    staticClass: "num_wrapper"
  }, [_c('p', {
    staticClass: "num-title"
  }, [_vm._v("成功交易笔数")]), _vm._v(" "), _c('p', {
    staticClass: "num-desc"
  }, [_vm._v(_vm._s(_vm.transData.sucnum || 0))])]), _vm._v(" "), _c('div', {
    staticClass: "num_wrapper"
  }, [_c('p', {
    staticClass: "num-title"
  }, [_vm._v("撤销笔数")]), _vm._v(" "), _c('p', {
    staticClass: "num-default"
  }, [_vm._v(_vm._s(_vm.transData.cancelnum || 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "a-wrapper"
  }, [_c('el-dropdown', [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('img', {
    attrs: {
      "src": require("./img/download.png"),
      "alt": "download"
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('a', {
    staticClass: "downDetail",
    attrs: {
      "href": _vm.detailHref,
      "download": ""
    }
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "1"
    }
  }, [_vm._v("下载交易明细")])], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.downCollection
    }
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "2"
    }
  }, [_vm._v("下载交易汇总")])], 1)])], 1)], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.transData.data,
      "row-class-name": "el-table__row_fix"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "店铺名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.username))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收银员"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.opuser || '-'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "busicd_info",
      "label": "交易类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sysdtm",
      "min-width": "150",
      "label": "交易时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.sysdtm))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "交易金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-title"
        }, [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.total_amt)) + _vm._s(_vm.role.currency))]), _vm._v(" "), _c('div', {
          staticClass: "table-content"
        }, [_vm._v("实收" + _vm._s(_vm._f("formatCurrency")(scope.row.txamt)) + _vm._s(_vm.role.currency))]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.mchnt_coupon),
            expression: "scope.row.mchnt_coupon"
          }],
          staticClass: "table-content"
        }, [_vm._v("商家红包" + _vm._s(_vm._f("formatCurrency")(scope.row.mchnt_coupon)) + _vm._s(_vm.role.currency))]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.hj_coupon),
            expression: "scope.row.hj_coupon"
          }],
          staticClass: "table-content"
        }, [_vm._v("平台补贴" + _vm._s(_vm._f("formatCurrency")(scope.row.hj_coupon)) + _vm._s(_vm.role.currency))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status_str",
      "label": "交易状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "syssn",
      "min-width": "210",
      "label": "流水号"
    }
  }), _vm._v(" "), (_vm.role.single) ? _c('el-table-column', {
    attrs: {
      "min-width": "100",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-button__fix",
          attrs: {
            "type": "text",
            "size": "small",
            "disabled": scope.row.cancel !== 0 || scope.row.status !== 1
          },
          on: {
            "click": function($event) {
              return _vm.confirm(scope.row)
            }
          }
        }, [_vm._v("撤销")])]
      }
    }], null, false, 2528020347)
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.transData.num >= 10) ? _c('div', {
    staticClass: "pagination_wrapper"
  }, [_c('el-pagination', {
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.transData.num,
      "current-page": _vm.currentPage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  })], 1) : _c('div', {
    staticClass: "table_placeholder"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.showConfirm,
      "custom-class": "mydialog",
      "top": "20%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showConfirm = $event
      },
      "close": function($event) {
        return _vm.handleClose('formpwd')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("若要撤销交易，请输入账户登录密码以确认操作")]), _vm._v(" "), _c('el-form', {
    ref: "formpwd",
    attrs: {
      "model": _vm.formpwd,
      "rules": _vm.pwdrules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入登录密码",
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.formpwd.pwd),
      callback: function($$v) {
        _vm.$set(_vm.formpwd, "pwd", $$v)
      },
      expression: "formpwd.pwd"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.checkPwd
    }
  }, [(_vm.iconLoading) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v("确 定")])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "交易流水Excel下载",
      "visible": _vm.showTotal,
      "custom-class": "mydialog extra",
      "top": "20%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showTotal = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("检测到门店有收银员角色，交易汇总是否要区分收银员？")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer total-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "separate",
    on: {
      "click": function($event) {
        _vm.showTotal = false
      }
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.separateHref,
      "download": "",
      "id": "separate"
    }
  }, [_vm._v("区分收银员")])]), _vm._v(" "), _c('div', {
    staticClass: "submit",
    on: {
      "click": function($event) {
        _vm.showTotal = false
      }
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.mergeHref,
      "download": ""
    }
  }, [_vm._v("合并收银员")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-04fa4b96"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/transctl/transctl.vue
// module id = 804
// module chunks = 0